// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.button.F_v1G{align-items:center;background:#0000;box-shadow:none;color:var(--anchore-color-gray-700);display:inline-flex;font-weight:400;height:2.5rem;margin:0;padding-bottom:0;padding-top:0}.ui.button.F_v1G:focus,.ui.button.F_v1G:focus-visible,.ui.button.F_v1G:hover,.ui.dropdown[aria-expanded=true] .ui.button.F_v1G{background:var(--anchore-color-gray-150);color:var(--anchore-color-gray-700)}.ui.button.F_v1G>.icon,.ui.button.F_v1G>.lucide{color:var(--anchore-color-blue-400)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `F_v1G`
};
module.exports = ___CSS_LOADER_EXPORT___;
